export default __webpack_public_path__ + "static/media/pen.1b14cebb.svg";